<div class="container">
  <div class="placeholder-text">
    <h2>404 - Not Found 🙃</h2>
    <p>Looks like the page you're trying to access does not exist or has been removed.</p>
    <img src="/assets/placeholder_tumble.svg" alt="" role="presentation" title="tumbling weeds of nothingness">
  </div>
</div>